import Phone from '@material-ui/icons/PhoneOutlined';
import Internet from '@material-ui/icons/LanguageOutlined';
import SMS from '@material-ui/icons/TextsmsOutlined';
import CallIncoming from '@material-ui/icons/PhoneCallbackOutlined';
import CallOutgoing from 'assets/img/icons/CallOutgoing';
import CallMissed from '@material-ui/icons/PhoneMissed';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/usageStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IConnectionTypeIconProps {
	type: string;
}

const ConnectionTypeIcon = ({ type }: IConnectionTypeIconProps) => {
	const classes = useStyles();

	const Icon = (() => {
		switch (type) {
			case 'DATA':
				return Internet;

			case 'SMS':
				return SMS;

			case 'VOICE INCOMING':
				return CallIncoming;

			case 'VOICE OUTGOING':
				return CallOutgoing;

			case 'VOICE MISSED':
				return CallMissed;

			case 'VOICE LOCAL':
			default:
				return Phone;
		}
	})();

	return <Icon className={classes.icon} />;
};

export default ConnectionTypeIcon;
